<template>
	<div>
		<div class="d-flex justify-space-between align-center mb-2 mt-2">
			<div class="input-wrap">
				<h5 class="mb-2">Reporte de alquileres</h5>
			</div>
			<div class="action-btn-wrap">
				<v-btn v-if="records.length > 0" color="accent" @click="clickDownloadExcel()">
					<v-icon left small>mdi-file-excel</v-icon> Exportar Excel
				</v-btn>
			</div>
		</div>
		<v-card color="secondary" class="pa-3">
			<v-row dense>
				<v-col cols="12" xl="3" lg="4" md="12" sm="12">
					<div class="form-group">
						<label class="control-label">Desde</label>
						<el-date-picker
							v-model="search.start"
							type="date"
							value-format="yyyy-MM-dd"
							format="dd/MM/yyyy"
							:picker-options="pickerOptions"
						></el-date-picker>
					</div>
				</v-col>
				<v-col cols="12" xl="3" lg="4" md="12" sm="12">
					<div class="form-group">
						<label class="control-label">Hasta</label>
						<el-date-picker
							v-model="search.end"
							type="date"
							value-format="yyyy-MM-dd"
							format="dd/MM/yyyy"
							:picker-options="pickerOptionsDates"
						></el-date-picker>
					</div>
				</v-col>
				<v-col cols="12" xl="3" lg="4" md="12" sm="12">
					<div class="form-group">
						<label class="control-label">Usuario</label>
						<el-select v-model="search.user_id" filterable clearable>
							<el-option
								v-for="user in users"
								:key="user.id"
								:label="user.name"
								:value="user.id"
							></el-option>
						</el-select>
					</div>
				</v-col>
				<v-col cols="12" xl="2" lg="4" md="12" sm="12">
					<el-button
						type="primary"
						icon="el-icon-search"
						class="btn-block mt-5"
						:loading="loading"
						@click="getData"
					></el-button>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12" xl="12" lg="12">
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-right">N°</th>
									<!-- <th class="text-right">HABITACIÓN</th> -->
									<th>CLIENTE</th>
									<th class="text-center">FECHA/HORA INGRESO</th>
									<th class="text-center">HAB.</th>
									<th class="text-center">TIPO.</th>
									<th class="text-center">FECHA/HORA SALIDA</th>
									<th class="text-center">D</th>
									<th class="text-center">P</th>
									<th class="text-right">PRECIO</th>
									<th class="text-right">TICKET N°</th>
									<th class="text-center">USUARIO</th>
									<th class="text-right">TOTAL</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, index) in records" :key="index">
									<td class="text-right">
										{{ index + 1 }}
									</td>
									<!-- <td class="text-right">
										<template v-for="(row, index) in row.items">
											<span :key="index">{{ row.room + " " }}</span>
										</template>
									</td> -->
									<td>{{ row.customer }}</td>
									<td class="text-center">{{ row.date_of_entry }}</td>
									<template v-if="row.items.length > 1">
									<td colspan="6" class="text-center">
										<v-simple-table dense>
										<template v-slot:default>
											<tbody>
											<tr
												v-for="(item) in row.items"
												:class="item.alert ? 'warning--text' : ''"
												:key="item.room"
											>
												<td>{{ item.room }}</td>
												<td>{{ item.room_type }}</td>
												<td>{{ item.date_of_exit + " " + item.time_of_exit }}</td>
												<td>{{ (row.period_id == '01') ? 0 : item.number_of_days }}</td>
												<td>{{ item.number_of_people }}</td>
												<td class="text-right">{{ item.total }}</td>
											</tr>
											</tbody>
										</template>
										</v-simple-table>
									</td>
									</template>
									<template v-else>
									<td class="text-center">{{ row.items[0].room }}</td>
									<td class="text-center">{{ row.items[0].room_type }}</td>
									<td class="text-center">{{ row.items[0].date_of_exit + " " + row.items[0].time_of_exit }}</td>
									<td class="text-center">{{ (row.period_id == '01') ? 0 : row.items[0].number_of_days }}</td>
									<td class="text-center">{{ row.items[0].number_of_people }}</td>
									<td class="text-right">{{ row.items[0].total }}</td>
									</template>
									<td class="text-right">{{ row.identifier }}</td>
									<td class="text-center">{{ row.user }}</td>
									<td class="text-right">
										<strong>{{ row.total }}</strong>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="10"></td>
									<td class="text-right"><strong class="font-black title">Total S/</strong></td>
									<td class="text-right title">
										<strong>{{ balance }}</strong>
									</td>
								</tr>
							</tfoot>
						</template>
					</v-simple-table>
				</v-col>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import dayjs from 'dayjs';
export default {
	data() {
		return {
			resource: 'reports/commands',
			records: [],
			users: [],
			loading: false,
			balance: 0.0,
			search: {
				start: dayjs()
					.startOf('month')
					.format('YYYY-MM-DD'),
				end: dayjs().format('YYYY-MM-DD'),
				user_id: null,
			},
			pickerOptions: {
				disabledDate: (time) => {
					time = dayjs(time).format('YYYY-MM-DD');
					return dayjs().format('YYYY-MM-DD') < time;
				},
			},
			pickerOptionsDates: {
				disabledDate: (time) => {
					time = dayjs(time).format('YYYY-MM-DD');
					return this.search.start > time;
				},
			},
		};
	},
	created() {
		this.getTables();
	},
	methods: {
		getTables() {
			this.$http.get(`/${this.resource}/tables`).then((response) => {
				this.users = response.data;
			});
		},
		async getData() {
			this.loading = true;
			await this.$http.post(`/${this.resource}/records`, this.search).then((response) => {
				this.records = response.data.records;
				this.balance = response.data.balance;

				this.loading = false;
			});
		},
		clickDownloadExcel() {
			this.$http({
				url: `/${this.resource}/excel`,
				method: 'GET',
				responseType: 'blob',
			}).then((response) => {
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', `ReporteAlquileres-${new Date().getTime()}.xlsx`);
				document.body.appendChild(fileLink);

				fileLink.click();
			});
		},
	},
};
</script>
